import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./MeasuringDeviceVerificationFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import MeasuringDeviceVerificationFormStepOne from "./MeasuringDeviceVerificationFormSteps/MeasuringDeviceVerificationFormStepOne";

const MeasuringDeviceVerificationForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        approvedBy: { value: _initialValues?.approvedBy?.uuid },
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="MeasuringDeviceVerificationForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <MeasuringDeviceVerificationFormStepOne
                {...formProps}
                {...props}
              />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default MeasuringDeviceVerificationForm;
